import { createSelector } from 'reselect'

import { SETUP_STEPS } from './constants'

const selectData = createSelector(
  (state) => state.accountSetup.data,
  (items) => items.filter((e) => SETUP_STEPS[e.step])
)
const selectLoader = (state) => state.accountSetup.loader
const selectError = (state) => state.accountSetup.error

const selectDoToCount = createSelector(
  selectData,
  (items) => items.filter((elem) => !elem.complete && !elem.dismissed).length
)

const selectStepLoader = (state) => state.accountSetup.stepLoader

export { selectData, selectLoader, selectError, selectDoToCount, selectStepLoader }
